import { ArrowLeftIcon, ArrowRightIcon } from '@ngg/icons';
import type { MouseEvent } from 'react';

import { cn } from '@/lib/utils';

export const PrevButton = ({
    isVisible,
    onClick,
    className,
}: {
    isVisible: boolean;
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
    className?: string;
}) => (
    <button
        type="button"
        onClick={onClick}
        tabIndex={isVisible ? 0 : -1}
        className={cn(
            'absolute left-3 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center bg-grey-100 text-black transition-opacity duration-300 max-md:hidden',
            !isVisible
                ? 'cursor-default opacity-0'
                : 'action-focus hover:bg-white',
            className,
        )}>
        <ArrowLeftIcon className="text-xl" />
    </button>
);

export const NextButton = ({
    isVisible,
    onClick,
    className,
    initialFocus,
}: {
    isVisible: boolean;
    onClick: (e: MouseEvent<HTMLButtonElement>) => void;
    className?: string;
    initialFocus?: any;
}) => (
    <button
        ref={initialFocus}
        type="button"
        onClick={onClick}
        tabIndex={isVisible ? 0 : -1}
        className={cn(
            'absolute right-3 top-1/2 z-10 flex h-8 w-8 -translate-y-1/2 items-center justify-center bg-grey-100 text-black transition-opacity duration-300 max-md:hidden',
            !isVisible
                ? 'cursor-default opacity-0'
                : ' action-focus hover:bg-white',
            className,
        )}>
        <ArrowRightIcon className="text-xl" />
    </button>
);
